
export class GetSettings {
  static readonly type = '[Settings] Get Settings'
}

export class ToggleAllEmails {
  static readonly type = '[Settings] Toggle All Emails'
}

export class EnableAllEmails {
  static readonly type = '[Settings] Enable All Emails'
}

export class DisableAllEmails {
  static readonly type = '[Settings] Disable All Emails'
}

export class GetEmailStatus {
  static readonly type = '[Settings] Get Email Status'
}

export class GenerateTestCandidates {
  static readonly type = '[Settings] Generate Test Candidates'
  constructor(public phase: 'phase1' | 'phase2', public examId?: string) {}
}

export class CleanupTestCandidates {
  static readonly type = '[Settings] Cleanup Test Candidates'
}
